import { render, staticRenderFns } from "./addedit-preventativebarrier.vue?vue&type=template&id=1413706b"
import script from "./addedit-preventativebarrier.vue?vue&type=script&lang=js"
export * from "./addedit-preventativebarrier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports